var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81781 2.81949C5.00943 3.24348 2.76343 5.56294 2.42573 8.54403L2.08085 11.5885C1.99516 12.345 1.68856 13.0569 1.20159 13.63C0.16818 14.8464 1.00691 16.75 2.57623 16.75H14.916C16.4853 16.75 17.324 14.8464 16.2906 13.63C15.8036 13.0569 15.497 12.345 15.4113 11.5885L15.1834 9.57673M11.7461 18.75C11.3094 19.9152 10.1311 20.75 8.74609 20.75C7.36106 20.75 6.18278 19.9152 5.74609 18.75M16.7461 3.75C16.7461 5.40685 15.4029 6.75 13.7461 6.75C12.0892 6.75 10.7461 5.40685 10.7461 3.75C10.7461 2.09315 12.0892 0.75 13.7461 0.75C15.4029 0.75 16.7461 2.09315 16.7461 3.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.fa4776d1daf57d1c570e66a9273c3b52.svg";
export { ForwardRef as ReactComponent };